import { Icon } from '@iconify/react'
import { FormEvent, useState } from 'react'
import { useAuth } from '../components/AuthContext'
import { Link } from 'react-router-dom'

export function LoginPage() {
  const { login } = useAuth()
  const [userId, setUserId] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!userId.trim() || !password.trim()) {
      setError('Both user ID and password are required.')
      return
    }
    setBusy(true)
    setError('')
    try {
      await login(userId.trim(), password)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed')
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950">
      <div className="w-full max-w-sm">
        <div className="panel">
          <div className="mb-6 flex items-center gap-3">
            <Icon icon="mdi:lock" width="28" height="28" className="text-cyan-400" />
            <h1 className="text-xl font-semibold text-white">MyScope Login</h1>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <label className="flex flex-col gap-1.5 text-sm text-slate-300">
              User ID
              <input
                className="field"
                type="text"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                placeholder="e.g. boby"
                autoFocus
                autoComplete="username"
              />
            </label>

            <label className="flex flex-col gap-1.5 text-sm text-slate-300">
              Password
              <input
                className="field"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Your phrase password"
                autoComplete="current-password"
              />
            </label>

            {error && (
              <p className="text-sm text-rose-300">
                <Icon icon="mdi:alert-circle" className="mr-1 inline" width="14" />
                {error}
              </p>
            )}

            <button className="btn flex items-center justify-center gap-2" disabled={busy}>
              {busy && <Icon icon="mdi:loading" width="16" className="animate-spin" />}
              {busy ? 'Logging in...' : 'Log in'}
            </button>
          </form>

          <p className="mt-4 text-center text-xs text-slate-400">
            No account?{' '}
            <Link to="/register" className="text-cyan-400 underline hover:text-cyan-300">
              Register
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
